import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AccountServiceProvider } from '../../providers/account-service/account-service';
import { Shareddata } from '../../providers/shareddata';
import { FuncsService } from '../../services/funcs.services';
import smoothscroll from 'smoothscroll-polyfill';

@Component({
	selector      : 'app-search',
	templateUrl   : './search.component.html',
	encapsulation : ViewEncapsulation.None
})

export class SearchComponent implements OnInit {
	formGroup : FormGroup;
	public searchData     : any = [];
	public searchDropDown : any = [];
	public searchOrg      : any = [];
	public tag_list_name  : any = [];
	public tag_list_id    : any = [];
	public schedule_data  : any = [];
	public searchText           : any;	
	public selectedSortOptions  : any;	
	public searchArea           : any;
	public searchId             : any;
	public userData             : any;	
	public scheduleSearchOption : any;
	public offset               : any;
	public dotnetresult         : any;
	public dotnettotal          : any;
	public scheduleType         : any;
	public action               : any = 'listing';	
	public searchCount   : number;
	public offset_params : number;
	public filterButton          : boolean = true;
	public loadMoreButton        : boolean = false;
	public showMoreButton        : boolean = false;
	public scheduleSearchResult  : boolean = false;
	public show_detail_page      : boolean = false;
	public showSelectedTagsText  : boolean = false;
	public showSelectedtags      : boolean = false;
	public showSelectedgold      : boolean = false;
	public showOpensession       : boolean = false;
	public showSelectedsession   : boolean = false;
	public defaultSearchPage     : boolean = false;
	public validation_error_show : boolean = false;

	public show_wp_data : any = [];
	public toshow_wp_data : any = [];
	public wplimit : number = 20;

	constructor(
		private router         : Router,
		private route          : ActivatedRoute,
		private location       : Location,		
		private accountService : AccountServiceProvider,
		public shareddata      : Shareddata,
		private funcs          : FuncsService,
	) {
		smoothscroll.polyfill();
		window.localStorage.setItem( 'httpReferer', this.router.url );
		var userData = this.funcs.globalSetUserSession();
		if ( userData )
			this.shareddata.setUserSession( userData );
		if ( 'filterSearchProgrammeKeys' in window.sessionStorage )
			sessionStorage.removeItem( 'filterSearchProgrammeKeys' );
	}

	@HostListener('window:popstate', ['$event'])
	onPopState(event) {
		location.reload();
	}

	ngOnInit() {
		var headerClass = document.getElementsByClassName( 'header');
		if ( ! headerClass[0].classList.contains( 'inner_page_menu' ) )
			headerClass[0].classList.add( 'inner_page_menu' );
		var text_search;
		var cur_url = this.router.url;
		if ( cur_url.includes( '?' ) ) {
			this.filterButton = true;
			cur_url = cur_url.split( '/search?search_text=')[1];
			cur_url = cur_url.split( '&search_area' )[0];			
			if ( 'siteSearch' in window.sessionStorage ) {
				let localItems = JSON.parse( sessionStorage.getItem( 'siteSearch' ) );
				text_search = localItems.search_text;
			} else {
				if ( undefined !== this.shareddata.searchText )
					text_search = this.shareddata.searchText;
				else
					text_search = cur_url;
			}
			this.shareddata.setSearchText( text_search );
			this.formGroup = new FormGroup({
				SearchText :new FormControl( text_search, [
					Validators.required,
				] ),
			});
			const search_text : string = this.route.snapshot.queryParamMap.get( 'search_text' );
	    	const search_area : string = this.route.snapshot.queryParamMap.get( 'search_area' );
	    	const search_id   : string = this.route.snapshot.queryParamMap.get( 'search_id' );
	    	this.searchText = search_text;
			let params = {
				'searchText' : search_text,
				'searchArea' : search_area,
				'searchId'   : search_id,
				'offset'     : 0,
			};
			this.getSearchDataResult( params, search_text, 'default' );
		} else {
			this.defaultSearchPage = true;
			this.formGroup = new FormGroup({
				SearchText :new FormControl( text_search, [
					Validators.required,
				] ),
			});
			let option_params = {
				current_option_id : 0,
			}
			this.accountService.getSearchOptions( option_params ).then( ( response: any ) => {
				if ( 'Ok' == response.status ) {
					this.searchDropDown      = response.menu_array;
					this.selectedSortOptions = response.current_option;
					this.shareddata.setSearchOption( this.selectedSortOptions );
				}
			});
		}
	}

	onSearchSubmitPage() {
		this.validation_error_show = false;
		this.filterButton = true;
		var element = document.getElementsByClassName( 'active-menu-search-dropdown' );
		this.searchArea = element[0].getAttribute( 'data-slug' );
		this.searchId   = element[0].getAttribute( 'data-id' );
		var searchAreaTitle = element[0].getAttribute( 'data-title' );
		var search_text = this.shareddata.searchText;		
		let params = {
			'searchText' : search_text,
			'searchArea' : this.searchArea,
			'searchId'   : this.searchId,
			'searchAreaTitle' : searchAreaTitle,
			'offset'     : 0,
		};		
		this.location.replaceState( 'search?search_text=' + search_text + '&search_area=' + params.searchArea + '&search_id=' + params.searchId );
		this.getSearchDataResult( params, search_text, 'default' );
	}
	/* search dropdown options */
	onSearchSubmitByOptions( event, options_id, option_slug, option_title ) {
		this.filterButton = true;
		/* change class */
		var elems = document.querySelectorAll( '.active-menu-search-dropdown' );
		[].forEach.call( elems, function( el ) {
			el.classList.remove( 'active-menu-search-dropdown' );
		});
		event.target.classList.add( 'active-menu-search-dropdown' );
		this.selectedSortOptions = option_title;
		var element = document.getElementsByClassName( 'active-menu-search-dropdown' );
		var searchAreaTitle = element[0].getAttribute( 'data-title' );
		/* change class */
		var search_text = this.shareddata.searchText;
		if ( undefined == search_text || '' == search_text || null == search_text )
			this.validation_error_show = true;
		else {
			this.validation_error_show = false;
			this.filterButton = true;
			let params = {
				'searchText' : search_text,
				'searchArea' : option_slug,
				'searchId'   : options_id,
				'searchAreaTitle' : searchAreaTitle,
				'offset'     : 0,
			};
			this.shareddata.setSearchOption( this.selectedSortOptions );
			this.shareddata.setSearchOptionId( options_id );			
			this.location.replaceState( 'search?search_text=' + search_text + '&search_area=' + option_slug + '&search_id=' + params.searchId );
			this.getSearchDataResult( params, search_text, 'default' );
		}
	}
	/* schedule option */
	onSearchSubmitByScheduleOptions( event, option_type ) {
		this.filterButton = true;
		var elems = document.querySelectorAll( '.current' );
		[].forEach.call( elems, function( el ) {
			el.classList.remove( 'current' );
		});
		event.target.classList.add( 'current' );
		this.scheduleSearchOption =  option_type[0].toUpperCase() + option_type.slice(1);
		var search_text = this.shareddata.searchText;
		var element = document.getElementsByClassName( 'active-menu-search-dropdown' );
		var searchArea = element[0].getAttribute( 'data-slug' );
		var searchId   = element[0].getAttribute( 'data-id' );
		var searchAreaTitle = element[0].getAttribute( 'data-title' );
		let params = {
			'searchText' : search_text,
			'searchArea' : searchArea,
			'searchId'   : searchId,
			'searchAreaTitle' : searchAreaTitle,
			'offset'     : 0,
		};
		this.shareddata.setSearchOption( searchArea );
		this.shareddata.setSearchOptionId( searchId );
		this.getSearchDataResult( params, search_text, 'default', option_type );
	}
	/* load more search result */
	loadMoreResultList( offset ) {
		this.loadMoreButton = true;
		this.showMoreButton = false;
		var search_text = this.shareddata.searchText;
		var element = document.getElementsByClassName( 'active-menu-search-dropdown' );
		var searchArea = element[0].getAttribute( 'data-slug' );
		var searchId   = element[0].getAttribute( 'data-id' );
		var searchAreaTitle = element[0].getAttribute( 'data-title' );
		var option_type = null;
		if ( 'event' == searchArea || 'exhibition' == searchArea ){
			this.offset = offset + 50;
			option_type = document.getElementsByClassName( 'current' )[0].innerHTML;
			option_type = option_type[0].toLowerCase() + option_type.slice(1);
		} else
			this.offset = offset + 20;
		let params = {
			'searchText' : search_text,
			'searchArea' : searchArea,
			'searchId'   : searchId,
			'searchAreaTitle' : searchAreaTitle,
			'offset'     : this.offset,
		};
		this.getSearchDataResult( params, search_text, 'more', option_type );
	}	
	/* search api */
	getSearchDataResult( params, search_text, search_type, option_type = null ) {
		this.offset = params.offset;
		let dotnetparams;
		let option_params = {
			current_option_id : params.searchId,
		}
		if ( 'siteSearch' in window.localStorage )
			localStorage.removeItem( 'siteSearch' );
		let myObj = {
			offset: this.offset,
			search_text: search_text,
			search_type: search_type,
			option_type: option_type,
			search_id: Number ( params.searchId ),
			search_type_title: params.searchAreaTitle,
		}
		sessionStorage.setItem( 'siteSearch', JSON.stringify( myObj ) );		
		let localItems = JSON.parse( sessionStorage.getItem( 'siteSearch' ) );
		this.searchText = localItems.search_text;
		this.shareddata.setSearchText( localItems.search_text );
		if ( 'default' === search_type ) {
			this.accountService.getSearchOptions( option_params ).then( ( response: any ) => {
				if ( 'Ok' == response.status ) {
					this.searchDropDown      = response.menu_array;
					this.selectedSortOptions = response.current_option;
					this.shareddata.setSearchOption( this.selectedSortOptions );
					if ( 'event' == params.searchArea || 'exhibition' == params.searchArea ) {
						this.scheduleSearchResult = true;
						this.scheduleType = params.searchArea;
						var optionType = option_type;					
						if ( null !== option_type ) {
							optionType = option_type;
							this.scheduleSearchOption = optionType[0].toUpperCase() + optionType.slice(1);
						} else {
							optionType = 'all';
							this.scheduleSearchOption = 'All';
						}
						params = {
							'offset' : 0,
							'type' : params.searchArea,
							'searchText' : params.searchText,
							'searchOption' : optionType,
						}
						if ( 'event' == params.type ) {
							if( 'filterSearchProgrammeKeys' in window.sessionStorage )
								sessionStorage.removeItem( 'filterSearchProgrammeKeys' );							
							let myObj = {
								offset            : 0,
								type              : params.searchArea,
								view              : 'list',
								favourites        : 0,
								filter_type_count : 0, /* count how many filter clicked(tags, weekdays, goldstandard ) */
								tag_id            : 0, /* tag id of current clicked tag */
								session_id        : 0, /* id of session clicked */
								filter_id         : 0, /* add tag id as array for multiple */
								tag_count         : 0, /* count how many tags clicked(tags only) */
								limit             : 50, /* data limit */
								goldstandard      : 0, /* for goldstandard */
								opensession       : 0,  /* for opensession */
								tag_names         : '', /* tag names as array */
								current_url       : this.router.url,
								search_option     : optionType,
								search_text       : params.searchText,
							};
							sessionStorage.setItem( 'filterSearchProgrammeKeys', JSON.stringify( myObj ) );
							let localSessionItems = JSON.parse( sessionStorage.getItem( 'filterSearchProgrammeKeys' ) );
						}
						this.getFilterData( params/*, localSessionItems*/ );
					} else if ( 'media' == params.searchArea || 'both' == params.searchArea || 'partner' == params.searchArea ) {
						this.scheduleSearchResult = false;
						this.searchData = '';
						params = {
							'offset' : 0,
							'org_type' : params.searchArea,
							'searchText' : params.searchText,
						}
						this.accountService.getOrganisations( params ).then( ( response: any ) => {
							this.searchOrg = response.organisations;
							this.searchCount = response.totalCount;
							if ( response.count == response.totalCount )
								this.showMoreButton = false;
							else
								this.showMoreButton = true;
						});
					} else if ( 'participants' == params.searchArea ) {
						this.scheduleSearchResult = false;
						this.searchData = '';
						dotnetparams = {
							'searchText' : search_text,
							'searchOption' : 'participant',
							'offset' : params.offset,
						}
						this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
							this.searchData = response.searchResult;
							this.searchCount = response.totalCount;
						});
					} else if ( 'speaker' == params.searchArea ) {
						this.scheduleSearchResult = false;
						this.searchData = '';
						dotnetparams = {
							'searchText' : search_text,
							'searchOption' : 'speaker',
							'offset' : params.offset,
						}
						this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
							this.searchData = response.searchResult;
							this.searchCount = response.totalCount;
							if ( this.searchData.length >= response.listLimit )
								this.showMoreButton = true;
							else
								this.showMoreButton = false;
						});
					} else if ( 'convening_organisation' == params.searchArea ) {
						this.scheduleSearchResult = false;
						this.searchData = '';
						dotnetparams = {
							'searchText' : search_text,
							'searchOption' : 'convenor',
							'offset' : params.offset,
						}
						this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
							this.searchData = response.searchResult;
							this.searchCount = response.totalCount;
							if ( this.searchData.length >= response.listLimit )
								this.showMoreButton = true;
							else
								this.showMoreButton = false;
						});
					} else if ( 'feed' == params.searchArea ) {
						this.scheduleSearchResult = false;
						this.searchData = '';
						dotnetparams = {
							'searchText' : search_text,
							'searchOption' : 'newsfeed',
							'offset' : params.offset,
						}
						this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
							this.searchData = response.searchResult;
							this.searchCount = response.totalCount;
							if ( this.searchData.length >= response.listLimit )
								this.showMoreButton = true;
							else
								this.showMoreButton = false;
						});
					} else if ( 'programme' == params.searchArea ) {
						this.scheduleSearchResult = false;
						this.searchData = '';
						dotnetparams = {
							'searchText' : search_text,
							'searchOption' : 'programme',
							'offset' : params.offset,
						}
						this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
							this.searchData = response.searchResult;
							this.searchCount = response.totalCount;
							if ( this.searchData.length >= response.listLimit )
								this.showMoreButton = true;
							else
								this.showMoreButton = false;
						});
					} else if ( 'community' == params.searchArea ) {
						this.scheduleSearchResult = false;
						this.searchData = '';
						dotnetparams = {
							'searchText' : search_text,
							'searchOption' : 'community',
							'offset' : params.offset,
						}
						this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
							this.searchData = response.searchResult;
							this.searchCount = response.totalCount;
							if ( this.searchData.length >= response.listLimit )
								this.showMoreButton = true;
							else
								this.showMoreButton = false;
						});
					} else if( 'normal' == params.searchArea || 'page' == params.searchArea ) {
						this.scheduleSearchResult = false;
						this.searchData = '';
						this.accountService.getSearchData( params ).then( ( response: any ) => {
							// this.searchData = response.content;
							this.searchCount = response.count;
							if ( this.searchCount > this.wplimit ) {
								this.searchData = response.content.slice( 0, this.wplimit ); /** take 1st this.wplimit data */
								response.content.splice( 0, this.wplimit ); /** remove 1st this.wplimit data */
								this.toshow_wp_data = response.content;
								if ( this.toshow_wp_data.length > this.wplimit ) {
									this.showMoreButton = true;
								} else {
									this.showMoreButton = false;
								}
							} else {
								this.searchData = response.content;
								this.showMoreButton = false;
							}
						});
					} else {
						this.scheduleSearchResult = false;
						this.searchData = '';
						dotnetparams = {
							'searchText' : search_text,
							'searchOption' : 'all',
							'offset' : 0,
						}
						Promise.all( [ this.accountService.getSearchData( params ), this.accountService.getSearchResult( dotnetparams ) ] ).then( result => {
							if ( 'Ok' == result[0]['status'] && result[0]['count'] > 0 && 'Ok' == result[1]['status'] && result[1]['searchResult'] != 'undefined' ) {
								this.dotnetresult = result[1]['searchResult'].length;
								this.dotnettotal = result[1]['totalCount'];
								this.wplimit = result[1].listLimit;
								if ( result[0]['content'].length > result[1].listLimit ) {
									this.show_wp_data = result[0]['content'].slice( 0, result[1].listLimit ); /** take 1st result[1].listLimit data */
									result[0]['content'].splice( 0, result[1].listLimit ); /** remove 1st result[1].listLimit data */
									this.toshow_wp_data = result[0]['content'];
								} else {
									this.show_wp_data = result[0]['content'];
								}
								if ( result[1]['totalCount'] > result[1]['searchResult'].length )
									this.searchData = result[1]['searchResult'];
								else
									this.searchData = [...result[1]['searchResult'], ...this.show_wp_data];
									// this.searchData = [...result[1]['searchResult'], ...result[0]['content']];
								this.searchCount = parseInt( result[0]['count'] ) + parseInt( result[1]['totalCount'] );
							} else {
								if ( 'Ok' == result[0]['status'] && result[0]['count'] > 0 ) {
									this.searchData  = result[0]['content'];
									this.searchCount = result[0]['count'];
								}
								if( 'Ok' == result[1]['status'] && result[1]['searchResult'] != 'undefined' ) {
									this.dotnetresult = result[1]['searchResult'].length;
									this.dotnettotal = result[1]['totalCount'];
									this.searchData  = result[1]['searchResult'];
									this.searchCount = result[1]['totalCount'];
								}
							}
							if ( this.searchCount == this.searchData.length )
								this.showMoreButton = false;
							else
								this.showMoreButton = true;
						});
					}
				}				
			})
		} else {
			if ( 'event' == params.searchArea || 'exhibition' == params.searchArea ) {
				this.scheduleSearchResult = true;
				this.scheduleType = params.searchArea;
				var optionType = option_type;				
				if ( null !== option_type )
					optionType = option_type;
				else
					optionType = 'all';
				params = {
					'offset' : params.offset,
					'type' : params.searchArea,
					'searchText' : params.searchText,
					'searchOption' : optionType,
				}
				this.getFilterData( params );
			} else if ( 'media' == params.searchArea || 'both' == params.searchArea || 'partner' == params.searchArea ) {
				this.scheduleSearchResult = false;
				params = {
					'offset' : params.offset,
					'org_type' : params.searchArea,
					'searchText' : params.searchText,
				}
				this.accountService.getOrganisations( params ).then( ( response: any ) => {
					if ( 0 < response.organisations.length ) {
						for ( let value of response.organisations )
							this.searchOrg.push( value );
					}
					this.searchCount = response.totalCount;
					if ( this.searchOrg.length == response.totalCount )
						this.showMoreButton = false;
					else
						this.showMoreButton = true;
				});
			} else if ( 'participants' == params.searchArea ) {
				this.scheduleSearchResult = false;
				dotnetparams = {
					'searchText' : search_text,
					'searchOption' : 'participant',
					'offset' : params.offset,
				}
				this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
					if ( 0 < response.searchResult.length ) {
						for ( let value of response.searchResult )
							this.searchData.push( value );
					}
					this.searchCount = response.totalCount;
					if ( this.searchData.length >= response.listLimit )
						this.showMoreButton = true;
					else
						this.showMoreButton = false;
				});
			} else if ( 'speaker' == params.searchArea ) {
				this.scheduleSearchResult = false;
				dotnetparams = {
					'searchText' : search_text,
					'searchOption' : 'speaker',
					'offset' : params.offset,
				}
				this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
					if ( 0 < response.searchResult.length ) {
						for ( let value of response.searchResult )
							this.searchData.push( value );
					}
					this.searchCount = response.totalCount;
					if ( this.searchData.length >= response.listLimit )
						this.showMoreButton = true;
					else
						this.showMoreButton = false;
				});
			} else if ( 'convening_organisation' == params.searchArea ) {
				this.scheduleSearchResult = false;
				dotnetparams = {
					'searchText' : search_text,
					'searchOption' : 'convenor',
					'offset' : params.offset,
				}
				this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
					if ( 0 < response.searchResult.length ) {
						for ( let value of response.searchResult )
							this.searchData.push( value );
					}
					this.searchCount = response.totalCount;
					if ( this.searchData.length >= response.listLimit )
						this.showMoreButton = true;
					else
						this.showMoreButton = false;
				});
			} else if ( 'feed' == params.searchArea ) {
				this.scheduleSearchResult = false;
				dotnetparams = {
					'searchText' : search_text,
					'searchOption' : 'newsfeed',
					'offset' : params.offset,
				}
				this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
					if ( 0 < response.searchResult.length ) {
						for ( let value of response.searchResult )
							this.searchData.push( value );
					}
					this.searchCount = response.totalCount;
					if ( this.searchData.length >= response.listLimit )
						this.showMoreButton = true;
					else
						this.showMoreButton = false;
				});
			} else if ( 'programme' == params.searchArea ) {
				this.scheduleSearchResult = false;
				dotnetparams = {
					'searchText' : search_text,
					'searchOption' : 'programme',
					'offset' : params.offset,
				}
				this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
					if ( 0 < response.searchResult.length ) {
						for ( let value of response.searchResult )
							this.searchData.push( value );
					}					
					this.searchCount = response.totalCount;
					if ( this.searchData.length >= response.listLimit )
						this.showMoreButton = true;
					else
						this.showMoreButton = false;
				});
			} else if ( 'community' == params.searchArea ) {
				this.scheduleSearchResult = false;
				dotnetparams = {
					'searchText' : search_text,
					'searchOption' : 'community',
					'offset' : params.offset,
				}
				this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
					if ( 0 < response.searchResult.length ) {
						for ( let value of response.searchResult )
							this.searchData.push( value );
					}
					this.searchCount = response.totalCount;
					if ( this.searchData.length >= response.listLimit )
						this.showMoreButton = true;
					else
						this.showMoreButton = false;
				});
			} else if( 'normal' == params.searchArea || 'page' == params.searchArea ) {
				this.scheduleSearchResult = false;
				// this.searchData = '';
				// this.accountService.getSearchData( params ).then( ( response: any ) => {
				// 	this.searchData = response.content;
				// 	this.searchCount = response.count;
				// 	this.showMoreButton = false;
				// });
				if ( this.toshow_wp_data.length > 0 ) {
					if ( this.toshow_wp_data.length > this.wplimit ) {
						this.show_wp_data = this.toshow_wp_data.slice( 0, this.wplimit );
						this.toshow_wp_data.splice( 0 , this.wplimit );
						for ( let value of this.show_wp_data ) {
							this.searchData.push( value );
						}
						if ( this.toshow_wp_data.length > 0 ) {
							this.showMoreButton = true;
						}
					} else {
						for ( let value of this.toshow_wp_data ) {
							this.searchData.push( value );
						}
						this.showMoreButton = false;
					}
				}
			} else {
				this.scheduleSearchResult = false;
				dotnetparams = {
					'searchText' : search_text,
					'searchOption' : 'all',
					'offset' : params.offset,
				}
				if ( this.dotnetresult != this.dotnettotal ) {
					this.accountService.getSearchResult( dotnetparams ).then( ( response: any ) => {
						this.dotnetresult += response.searchResult.length;
						for ( let value of response.searchResult )
							this.searchData.push( value );
						if ( this.searchData == 0 )
							this.showMoreButton = false;
						else
							this.showMoreButton = true;
					});
				} else {
					if ( this.toshow_wp_data.length > 0 ) {
						if ( this.toshow_wp_data.length > this.wplimit ) {
							this.show_wp_data = this.toshow_wp_data.slice( 0, this.wplimit );
							this.toshow_wp_data.splice( 0 , this.wplimit );
							for ( let value of this.show_wp_data ) {
								this.searchData.push( value );
							}
							if ( this.toshow_wp_data.length > 0 ) {
								this.showMoreButton = true;
							}
						} else {
							for ( let value of this.toshow_wp_data ) {
								this.searchData.push( value );
							}
							this.showMoreButton = false;
						}
					}
					// this.accountService.getSearchData( params ).then( ( response: any ) => {
					// 	for ( let value of response.content )
					// 		this.searchData.push( value );
					// 	this.showMoreButton = false;
					// });
				}
			}
		}
		
		setTimeout(() => {
			this.filterButton = false;
			this.loadMoreButton = false;
		}, 1 );
	}

	goToLoginPage() {
		document.getElementById( 'pageaccountclick' ).click();
	}
	/* highlight the search text in search result within title, content, convenor */
	highlight_search_text( content, type = null, position = null ) {
		return this.funcs.globalHighlightSearchText( content );
	}

	filterMore( event : any, filter_type, filter_id, filter_name ) {
		this.filterButton = true;
		var tag_id;
		var tag_name;
		var filter_type_count = 0;
		var goldstandard = 0;
		var opensession = 0;
		var session_id = 0;
		if( event.target.classList.contains( 'activated' ) )
			this.removeFilter( event, filter_type, filter_id, filter_name );
		else {
			var option_type;
			var search_text = this.shareddata.searchText;
			var element = document.getElementsByClassName( 'active-menu-search-dropdown' );
			var searchArea = element[0].getAttribute( 'data-slug' );
			option_type = document.getElementsByClassName( 'current' )[0].innerHTML;
			option_type = option_type[0].toLowerCase() + option_type.slice(1);
			if ( 'filterSearchProgrammeKeys' in window.sessionStorage ) {
				let localSessionItems = JSON.parse( sessionStorage.getItem( 'filterSearchProgrammeKeys' ) );
				if ( 'tags' == filter_type ) {
					let tag_count       = localSessionItems.tag_count;
					if ( 'goldstandard' != filter_name && 'opensession' != filter_name ) {
						if ( 0 != filter_id ) {
							this.showSelectedTagsText = true;
							this.showSelectedtags = true;
							filter_type_count = localSessionItems.filter_type_count + 1;
							tag_id = localSessionItems.filter_id;
							if ( tag_id != '0') {
								localSessionItems.tag_count = localSessionItems.tag_count + 1;
								tag_id = tag_id + ',' + filter_id;
								tag_name = localSessionItems.tag_names + ',' + filter_name;
							} else {
								localSessionItems.tag_count = 1;
								tag_id = filter_id;
								tag_name = filter_name;
							}
							this.tag_list_name.push( filter_name );
							this.tag_list_id.push( filter_id );
						} else {
							filter_type_count = localSessionItems.filter_type_count - localSessionItems.tag_count;
							tag_id = filter_id;
							localSessionItems.tag_count = 0;
							if ( 0 != localSessionItems.goldstandard ) {
								this.showSelectedTagsText = true;
								this.showSelectedtags = false;
								this.showSelectedgold = true;
								this.tag_list_id.forEach( ( itemid, index ) => {
									if( itemid != 5000 )
										this.tag_list_id.splice( index, 1 );
								});
								this.tag_list_name.forEach( ( itemname, index ) => {
									if( itemname != 'goldstandard' )
										this.tag_list_name.splice( index, 1 );
								});
							} else if ( 0 != localSessionItems.opensession ) {
								this.showSelectedTagsText = true;
								this.showSelectedtags = false;
								this.showOpensession = true;
								this.tag_list_id.forEach( ( itemid, index ) => {
									if( itemid != 25000 )
										this.tag_list_id.splice( index, 1 );
								});
								this.tag_list_name.forEach( ( itemname, index ) => {
									if( itemname != 'opensession' )
										this.tag_list_name.splice( index, 1 );
								});
							} else {
								this.showSelectedTagsText = false;
								this.showSelectedtags = false;
								this.tag_list_id = [];
								this.tag_list_name = [];
							}						
						}
					} else {
						this.showSelectedTagsText = true;
						if ( 'opensession' != filter_name  ) {
							this.showSelectedgold = true;
							var goldstandard = 1;
						} else {
							this.showOpensession = true;
							var opensession = 1;
						}
						this.tag_list_name.push( filter_name );
						this.tag_list_id.push( filter_id );
					}
				} else {
					filter_type_count = localSessionItems.filter_type_count + 1;					
					if ( 0 != filter_id )
						this.showSelectedsession = true;
					else
						this.showSelectedsession = false;
					tag_id = filter_id;
				}
				let params = {
					'offset'            : 0,
					'type'              : searchArea,
					'searchOption'     : option_type,
					'searchText'       : search_text,
					'filter_type'       : filter_type,
					'filter_id'         : filter_id,
					'filter_type_count' : filter_type_count,
				};
				/* update sessionStorage for search text */
				localSessionItems.offset = params.offset;
				localSessionItems.filter_type_count = filter_type_count;
				localSessionItems.filter_type = filter_type;
				if ( 'tags' == filter_type ) {
					if ( 'goldstandard' != filter_name && 'opensession' != filter_name ) {
						localSessionItems.tag_id = filter_id;
						localSessionItems.filter_id = tag_id;
						localSessionItems.tag_names = tag_name;
					} else {
						if ( 'opensession' != filter_name )
							localSessionItems.goldstandard = goldstandard;
						else
							localSessionItems.opensession = opensession;
					}			
				} else if ( 'session' == filter_type )
					localSessionItems.session_id = filter_id;
		 		if ( localSessionItems.current_url.indexOf( '?' ) >= 0 ) {
					var urlValue = document.location.href;
					localSessionItems.current_url = localSessionItems.current_url.split( '?' )[0];
				}
				localSessionItems.search_text = search_text;
				localSessionItems.search_option = option_type;
				sessionStorage.setItem( 'filterSearchProgrammeKeys', JSON.stringify( localSessionItems ) );
				this.getFilterData( params/*, localSessionItems*/ );
			} else {
				if ( 'tags' == filter_type ) {
					let tag_count       = 0;
					if ( 'goldstandard' != filter_name && 'opensession' != filter_name ) {
						if ( 0 != filter_id ) {
							this.showSelectedTagsText = true;
							this.showSelectedtags = true;
							filter_type_count = 1;
							tag_id = filter_id;
							tag_name = filter_name;
							this.tag_list_name.push( filter_name );
							this.tag_list_id.push( filter_id );
						}
					} else {
						this.showSelectedTagsText = true;
						if ( 'opensession' != filter_name  ) {
							this.showSelectedgold = true;
							goldstandard = 1;
						} else {
							this.showOpensession = true;
							opensession = 1;
						}
						this.tag_list_name.push( filter_name );
						this.tag_list_id.push( filter_id );
					}
				} else {
					if ( 0 != filter_id )
						this.showSelectedsession = true;
					else
						this.showSelectedsession = false;
					session_id = filter_id;
				}
				let params = {
					'offset'        : 0,
					'type'          : searchArea,
					'tag_id'        : tag_id,
					'session_id'    : session_id,
					'goldstandard'  : goldstandard,
					'opensession'   : opensession,
					'filter_id'     : tag_id,
					'searchOption' : option_type,
					'searchText'   : search_text,
				};				
				/* update sessionStorage for search text */
				let myObj = {
					offset            : 0,
					type              : searchArea,
					view              : 'list',
					favourites        : 0,
					filter_type_count : 1, /* count how many filter clicked(tags, weekdays, goldstandard ) */
					tag_id            : tag_id, /* tag id of current clicked tag */
					session_id        : session_id, /* id of session clicked */
					filter_id         : tag_id, /* add tag id as array for multiple */
					tag_count         : 1, /* count how many tags clicked(tags only) */
					limit             : 50, /* data limit */
					goldstandard      : goldstandard, /* for goldstandard */
					opensession       : opensession,  /* for opensession */
					tag_names         : this.tag_list_name, /* tag names as array */
					current_url       : this.router.url,
					search_option     : option_type,
					search_text       : search_text,
				};
				sessionStorage.setItem( 'filterSearchProgrammeKeys', JSON.stringify( myObj ) );
				let localSessionItems = JSON.parse( sessionStorage.getItem( 'filterSearchProgrammeKeys' ) );
				this.getFilterData( params/*, localSessionItems*/ );
			}		
		}
	}

	removeFilter( event, filter_type, filter_id, filter_name ) {
		var option_type;
		var search_text = this.shareddata.searchText;
		option_type = document.getElementsByClassName( 'current' )[0].innerHTML;
		option_type = option_type[0].toLowerCase() + option_type.slice(1);
		this.filterButton = true;
		event.target.classList.remove( 'activated' );
		var element = document.getElementsByClassName( 'active-menu-search-dropdown' );
		var searchArea = element[0].getAttribute( 'data-slug' );
		let localSessionItems = JSON.parse( sessionStorage.getItem( 'filterSearchProgrammeKeys' ) );		
		var filter_type_count = localSessionItems.filter_type_count;
		if ( 'session' != filter_type && 'goldstandard' != filter_type && 'opensession' != filter_type )
			filter_type_count = localSessionItems.filter_type_count - 1;
		if ( 'tags' == filter_type ) {
			let tag_count       = localSessionItems.tag_count;
			if ( 'goldstandard' != filter_name && 'opensession' != filter_name ) {
				if ( 1 < tag_count ) {
					this.showSelectedTagsText = true;
					this.showSelectedtags = true;
					var tag_array = localSessionItems.filter_id.split( ',' );
					tag_array.forEach( ( item, index ) => {
	                    if ( filter_id == item )
	                    	tag_array.splice( index, 1 );
	                });
	                tag_array.join( ',' );
	                localSessionItems.filter_id = tag_array.toString();
					var tag_name_array = localSessionItems.tag_names.split( ',' );
					tag_name_array.forEach( ( item, index ) => {
	                    if ( filter_name == item )
	                    	tag_name_array.splice( index, 1 );
	                });
	                tag_name_array.join( ',' );
	                localSessionItems.tag_names = tag_name_array.toString();
	                this.tag_list_name.forEach( ( name, index ) => {
	                	if ( filter_name == name )
	                		this.tag_list_name.splice( index, 1 );
	                });
	                this.tag_list_id.forEach( ( id, index ) => {
	                	if ( filter_id == id )
	                		this.tag_list_id.splice( index, 1 );
	                });
				} else {
					if ( 0 !== localSessionItems.goldstandard ) {
						this.showSelectedTagsText = true;
						this.showSelectedtags = false;
						this.showSelectedgold = true;
						this.tag_list_name.forEach( ( name, index ) => {
		                	if ( filter_name == name )
		                		this.tag_list_name.splice( index, 1 );
		                });
		                this.tag_list_id.forEach( ( id, index ) => {
		                	if ( filter_id == id )
		                		this.tag_list_id.splice( index, 1 );
		                });
					} else if ( 0 !== localSessionItems.opensession ) {
						this.showSelectedTagsText = true;
						this.showSelectedtags = false;
						this.showOpensession = true;
						this.tag_list_name.forEach( ( name, index ) => {
		                	if ( filter_name == name )
		                		this.tag_list_name.splice( index, 1 );
		                });
		                this.tag_list_id.forEach( ( id, index ) => {
		                	if ( filter_id == id )
		                		this.tag_list_id.splice( index, 1 );
		                });
					} else {
						this.showSelectedTagsText = false;
						this.showSelectedtags = false;
						this.tag_list_id = [];
						this.tag_list_name = [];							
					}
					localSessionItems.tag_id = 0;
					localSessionItems.filter_id = 0;
				}
				localSessionItems.tag_count = tag_count - 1;
			} else {
				if ( 'opensession' != filter_name ) {
					localSessionItems.goldstandard = 0;
					if ( tag_count >= 1 ) {
						this.showSelectedTagsText = true;
						this.showSelectedgold = false;
						this.tag_list_name.forEach( ( name, index ) => {
		                	if ( filter_name == name )
		                		this.tag_list_name.splice( index, 1 );
		                });
		                this.tag_list_id.forEach( ( id, index ) => {
		                	if ( filter_id == id )
		                		this.tag_list_id.splice( index, 1 );
		                });											
					} else {
						this.showSelectedTagsText = false;
						this.showSelectedgold = false;
						this.tag_list_id  = [];
						this.tag_list_name = [];
					}
				} else {
					localSessionItems.opensession = 0;
					if ( tag_count >= 1 ) {
						this.showSelectedTagsText = true;
						this.showOpensession = false;
						this.tag_list_name.forEach( ( name, index ) => {
		                	if ( filter_name == name )
		                		this.tag_list_name.splice( index, 1 );
		                });
		                this.tag_list_id.forEach( ( id, index ) => {
		                	if ( filter_id == id )
		                		this.tag_list_id.splice( index, 1 );
		                });											
					} else {
						this.showSelectedTagsText = false;
						this.showOpensession = false;
						this.tag_list_id  = [];
						this.tag_list_name = [];
					}
				}
			}
		} else {
			this.showSelectedsession = false;
			localSessionItems.session_id = '0';
		}
		localSessionItems.filter_type_count = filter_type_count;
		window.sessionStorage.setItem( 'filterSearchProgrammeKeys', JSON.stringify( localSessionItems ) );		
		let params = {
			'offset'            : localSessionItems.offset,
			'type'              : searchArea,
			'searchOption'     : option_type,
			'searchText'       : search_text,
		};
		this.getFilterData( params/*,  localSessionItems*/);
	}

	getFilterData( params/*, localSessionItems*/ ) {
		this.loadMoreButton = false;
		this.showMoreButton = false;
		/* sessionStorage */
		this.offset_params = params.offset;
		this.accountService.getProgrammesByFilterSearch( params ).then( ( dotnetresponse: any ) => {
			if ( dotnetresponse.status == 'Ok' ) {
				this.schedule_data = dotnetresponse.programmes;
				this.searchData = dotnetresponse.programmes;
				this.searchCount = dotnetresponse.searchResultCount;
				if( this.searchData.length >= dotnetresponse.limit )
					this.showMoreButton = true;
				else
					this.showMoreButton = false;
			}			
			let count = this.searchData.length;
			if ( count >= dotnetresponse.limit )
				this.showMoreButton = true;
			else
				this.showMoreButton = false;
			this.loadMoreButton = false;
			this.filterButton = false;
		});
	}

	onSearchChange( searchValue : string ) {
		this.shareddata.setSearchText( searchValue );		
	}
}